// Navbar.jsx
import { useState } from 'react';
import { Link } from 'react-router-dom';
import arvrImg from '../assets/arvr-navbar.png';
import coretechImg from '../assets/core-navbar.png';
import creatorsImg from '../assets/creator-navbar.png';
import droneImg from '../assets/drone-navbar.png';
import robotImg from '../assets/robot-navbar.png';
import logo from '../assets/skipper-black.png';
import startupImg from '../assets/startup-navbar.png';
import uiuxImg from '../assets/uiux-navbar.png';
import './Navbar.css';

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(null);

  const toggleDropdown = (menu) => {
    if (window.innerWidth <= 768) {
      setDropdownOpen(dropdownOpen === menu ? null : menu);
    }
  };

  return (
    <nav className="navbar">
      <div className="left-section">
        <a href="/"><img src={logo} alt="Skipper Logo" className="logo-img" /></a>

        {/* Always visible Learn button */}
        <div className="nav-item dropdown" onClick={() => toggleDropdown('learn')}>
          <span className="navbar-learn">Learn </span>
          <span className="arrow">▾</span>

          <div className={`dropdown-menu mega-dropdown ${dropdownOpen === 'learn' ? 'show' : ''}`}>
            
            <div className="mega-column">
              <h3>Entrepreneur</h3>
              <p>Upgrade your life — one course at a time.</p>

              <div className="mega-card">
                <Link to="/Digitalpreneur" className="card-link">
                  <img src={startupImg} alt="Startup Stack" />
                  <div className="card-text">
                    <h4>Digitalpreneur</h4>
                    <span>For Creators</span>
                  </div>
                </Link>
              </div>



               
              {/*<div className="mega-column" id='mega-column-psy'>
              <h3>Doers</h3>
              <p className="mega-card-psy-span">Your Growth Journey Starts Here.</p>

              <div className="mega-card">
                <Link to="/psychology" className="card-link">
                  <img src={startupImg} alt="Startup Stack" />
                  <div className="card-text">
                    <h4>Psychology</h4>
                    <span >Mind Strategy Experts</span>
                  </div>
                </Link>
              </div>
              

            </div>*/}

            </div>
            
            
            <div className="mega-column">
              <h3>Innovators</h3>
              <p>Dive into today’s Trendiest Innovations</p>

              <div className="mega-card">
                <Link to="/drone-engineering" className="card-link">
                  <img src={droneImg} alt="Drone Engineering" />
                  <div className="card-text">
                    <h4>Drone Engineering</h4>
                    <span>3 Months</span>
                  </div>
                </Link>
              </div>

              <div className="mega-card">
                <Link to="/robot-engineering" className="card-link">
                  <img src={robotImg} alt="Robot Engineering" />
                  <div className="card-text">
                    <h4>Robot Engineering</h4>
                    <span>3 Months</span>
                  </div>
                </Link>
              </div>

              <div className="mega-card">
                <Link to="/ar-vr" className="card-link">
                  <img src={arvrImg} alt="AR VR" />
                  <div className="card-text">
                    <h4>AR VR</h4>
                    <span>3 Months</span>
                  </div>
                </Link>
              </div>

              <div className="mega-card">
                <Link to="/ui-ux-design-pro" className="card-link">
                  <img src={uiuxImg} alt="UI UX Design Pro" />
                  <div className="card-text">
                    <h4>UI UX Design Pro</h4>
                    <span>12 Weeks</span>
                  </div>
                </Link>
              </div>
            </div>

            <div className="mega-column">
              <h3>Super Stack</h3>
              <p>All-in-one bundles to grow and create</p>

              <div className="mega-card">
                <Link to="/creator-hub" className="card-link">
                  <img src={startupImg} alt="Startup Stack" />
                  <div className="card-text">
                    <h4>Creators Hub</h4>
                    <span>5+ Program</span>
                  </div>
                </Link>
              </div>

              <div className="mega-card">
                <Link to="/core-tech" className="card-link">
                  <img src={coretechImg} alt="Core Tech" />
                  <div className="card-text">
                    <h4>Core Tech</h4>
                    <span>5 Programs</span>
                  </div>
                </Link>
              </div>

              <div className="mega-card">
                <Link to="/medical-edition" className="card-link">
                  <img src={creatorsImg} alt="Creators Hub" />
                  <div className="card-text">
                    <h4>Medical Edition</h4>
                    <span>2 Program</span>
                  </div>
                </Link>
              </div>

              <div className="mega-card">
                <Link to="/Startup-Stack" className="card-link">
                  <img src={creatorsImg} alt="Creators Hub" />
                  <div className="card-text">
                    <h4>Startup-Stack</h4>
                    <span>7 Program</span>
                  </div>
                </Link>
              </div>
            </div>


            
            
          </div>
        </div>

        <Link to="/ui-ux-design-pro" className="nav-uiux-featured">
          <span className="nav-uiux-label">
            UI UX Design{' '}
            <span className="nav-uiux-pro">
              <span className="nav-uiux-tag">BESTSELLER 🔥</span>
              Pro
            </span>
          </span>
        </Link>

        {/* Hamburger-only links */}
        <div className={`nav-linkss ${open ? 'show' : ''}`}>
          <span className="nav-item">
            <span className="navbar-member">
              <Link to="/about" className="navlink">About</Link>
            </span>
          </span>
        </div>
      </div>

      <div className={`nav-buttons ${open ? 'show' : ''}`}>
        <Link to="/ui-ux-design-pro" className="nav-uiux-featured nav-uiux-featured-mobile">
          <span className="nav-uiux-label">
            UI UX Design{' '}
            <span className="nav-uiux-pro">
              <span className="nav-uiux-tag">BESTSELLER 🔥</span>
              Pro
            </span>
          </span>
        </Link>
        <Link to="/login" className="navlink"><button className="btn black">Login</button></Link>
        <Link to="/contact" className="navlink"><button className="btn white">Contact Us</button></Link>
      </div>

      <button
        className={`hamburger ${open ? 'open' : ''}`}
        onClick={() => setOpen(!open)}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
    </nav>
  );
};

export default Navbar;



